import { Component, inject, input } from '@angular/core';

import { ColorPickerDirective } from 'ngx-color-picker';

import { FeatureLike } from 'ol/Feature';

import { TerritoryTypesStore } from '../../../territory-types.store';

@Component({
  imports: [ColorPickerDirective],
  selector: 'norupe-color-switcher',
  templateUrl: './color-switcher.component.html',
})
export class ColorSwitcherComponent {
  feature = input.required<FeatureLike>();

  readonly territoryTypesStore = inject(TerritoryTypesStore);

  getColorInputValue(featureLike: FeatureLike) {
    const id = featureLike.get('type_id') as number;
    const item = this.territoryTypesStore.entityMap()[id];
    return item.style_json['fill-color'] as string;
  }

  changeColorInputValue(value: string, feature: FeatureLike) {
    const id = feature.get('type_id') as number;
    const item = this.territoryTypesStore.entityMap()[id];
    item.style_json['fill-color'] = value;
  }

  saveColorInputValue(feature: FeatureLike) {
    this.territoryTypesStore.saveTerritoryType(
      feature.get('type_id') as number,
    );
  }
}
